<template>
  <div>

    <gmap-map ref="mapRef" :center="center" :zoom="5" style="width:100%;  height: 400px;">
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center = m.position"
        :icon="{ url: require('../assets/blue-dot.png') }"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'
import { mapState } from "vuex";

export default {
  name: "Map",

  data() {
    return {
      center: { lat: -19.258965, lng: 146.816956 },
      places: [],
      currentPlace: null
    };
  },
  computed: {
    google: gmapApi,
    ...mapState("sites", {
      items: state => state.sites,
      markers(state) {
        let markers = [];
        state.sites.forEach(function (loc) {
          const marker = {
            lat: parseFloat(loc.LATITUDE),
            lng: parseFloat(loc.LONGITUDE)
          };
          markers.push({position: marker});
        });
        return markers;
      },
      bounds(state) {
        let bounds = new google.maps.LatLngBounds();
        state.sites.forEach(function (loc) {
          const marker = {
            lat: parseFloat(loc.LATITUDE),
            lng: parseFloat(loc.LONGITUDE)
          };
          bounds.extend(marker);
        });
        return bounds;
      }
    }),
  },
  mounted() {
    this.$store.dispatch("sites/getSites").then(
      () => {
        if (this.items.length > 0) {
          this.$refs.mapRef.$mapPromise.then((map) => {
            this.fitMap(map);
          })
        }
      },
      error => {
      }
    );
  },

  methods: {
    fitMap(map){
      map.fitBounds(this.bounds);
      google.maps.event.addListenerOnce(map, 'bounds_changed',
        function () {
          this.setZoom(Math.min(15, this.getZoom()));
        });
    }
  }
};
</script>
